import React from "react";
// import CardBanner from "../../../components/CardBanner/CardBanner";
import CardSlider from "../../../components/CardSlider/CardSlider";
import { Box } from "@mui/material";

interface ResponsiveBannerProps {
  src: string;
  alt: string;
}

const ResponsiveBanner: React.FC<ResponsiveBannerProps> = ({ src, alt }) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        draggable={false}
        sx={{
          width: "100%",
          height: "auto",
          display: "block",
          maxWidth: 1600,
          margin: "0 auto",
          objectFit: "cover",
          userSelect: "none",
          webkitUserDrag: "none",
        }}
      />
    </Box>
  );
};

const getSeasonalBannerData = () => {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const isChristmasSeason = month === 12 && day <= 26;
  const isNewYearSeason =
    (month === 12 && day >= 27) || (month === 1 && day <= 2);

  if (isChristmasSeason) {
    return { src: "images/natal.png", alt: "Banner de Feliz Natal" };
  }
  if (isNewYearSeason) {
    return { src: "images/new-year.png", alt: "Banner de Feliz Ano Novo" };
  }
  return { src: "images/banner.jpg", alt: "Banner Institucional Ream" };
};

const DynamicBanner = () => {
  const banner = getSeasonalBannerData();
  return <ResponsiveBanner src={banner.src} alt={banner.alt} />;
};

const itemsCards = [<DynamicBanner key="dynamic-banner" />];

const BannerContainer: React.FC = () => {
  return (
    <Box>
      <CardSlider componentItems={itemsCards} />
    </Box>
  );
};

export default BannerContainer;
